import { deviceType } from "@config";
import useCustomerServiceContact from "@hooks/useCustomerServiceContact";

interface ContactQrcode {
  name: string;
  link?: string;
  qrcode: string;
}

export const CommunityPosition = {
  REGISTER: "register",
};

export const useContactOne = () => {
  const { customerServiceContact } = useCustomerServiceContact();
  if (customerServiceContact?.im && customerServiceContact?.im.length > 0) {
    return customerServiceContact.im[0];
  }
  if (customerServiceContact?.community) {
    return customerServiceContact?.community;
  }
};

export const useContactGroup = (position?: string): ContactQrcode | undefined => {
  const { customerServiceContact } = useCustomerServiceContact();
  if (position && customerServiceContact?.communityMap?.[deviceType]?.[position]) {
    return customerServiceContact?.communityMap?.[deviceType]?.[position];
  }
  if (customerServiceContact?.community) {
    return customerServiceContact?.community;
  }
  if (customerServiceContact?.im && customerServiceContact?.im.length > 0) {
    return customerServiceContact.im[0];
  }
};
